import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import CreateDiffuseurModal from '../modals/CreateDiffuseurModal';
import { useAddCampagneDiffuseurMutation, useGetCampagneDiffuseurQuery, useRemoveCampagneDiffuseurMutation, useUpdateCampagneDiffuseurMutation } from '../../../../redux/api/cache';

export default function Diffuseur(props) {
  const [createModal, setCreateModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [addCampagneDiffuseur] = useAddCampagneDiffuseurMutation();
  const [updateCampagneDiffuseur] = useUpdateCampagneDiffuseurMutation();
  const [removeCampagneDiffuseur] = useRemoveCampagneDiffuseurMutation();
  const { data } = useGetCampagneDiffuseurQuery({ seq: props.project.camp_seq, media: props.mediaKey });
  const fileClicked = (rowData) => {
    setSelectedRow(rowData);
    setCreateModal(true);
  };

  const remove = async () => {
    await removeCampagneDiffuseur({ seq: props.project.camp_seq, media: props.mediaKey, rid: selectedRow.rid });
  };

  const create = async (values) => {
    if (selectedRow === undefined) {
      await addCampagneDiffuseur(values);
    } else {
      await updateCampagneDiffuseur(values);
    }
  };

  return (
    <Fragment>
      {createModal && (
        <CreateDiffuseurModal
          rowData={props.project}
          selectedRow={selectedRow}
          media={props.mediaKey}
          create={create}
          remove={remove}
          toggleDialog={() => {
            setCreateModal(false);
            setSelectedRow(undefined);
          }}
        />
      )}
      <GenericGrid
        autoSize={true}
        showCreateBtn={true}
        onCreateClick={() => {
          setSelectedRow(undefined);
          setCreateModal(true);
        }}
        rowClicked={fileClicked}
        definition={data.meta.definition}
        txtBtn="Ajouter un diffuseur"
        data={data.data}
      ></GenericGrid>
    </Fragment>
  );
}

Diffuseur.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.array,
    meta: PropTypes.shape({
      definition: PropTypes.array,
    }),
  }),
  mediaKey: PropTypes.string,
  path: PropTypes.string,
  project: PropTypes.shape({
    camp_seq: PropTypes.any,
  }),
};
